import { TextField } from "@material-ui/core";
import React, {useEffect, useState} from "react";
import axios from "axios";
import FormControl from "@material-ui/core/FormControl";
import userAuthenticationConfig from "../../../utils/userAuthenticationConfig";
import { Autocomplete, Skeleton } from "@material-ui/lab";
import Notification from "../notification/Notification";
import { parseAxiosError } from "../../../utils/response";
import { HTTP_STATUSES, STANDARD_ERRORS_WAY } from "../../../utils/consts";
import FormHelperText from "@material-ui/core/FormHelperText";
import { useTranslation } from "react-i18next";

const ConnectionsSelect = ({
  checkedConnection,
  setCheckedConnection,
  project = null,
  user = null,
  service,
  isObject = true,
  defaultOption = false,
  error = null,
  refField= null,
  autoSelectSingle = false
}) => {

  const {t} = useTranslation("otherInterface");

  const [connections, setConnections] = useState(null);
  const [fetchingConnections, setFetchingConnections] = useState(true);

  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });

  useEffect(() => {
    if ((!project && !user) || !service) {
      setNotification({
        ...notification,
        visible: true,
        type: "error",
        message: "Not found project, user or service"
      });
      return;
    }

    let filterUrl = "?service.name=" + service;

    if (project) {
      filterUrl += "&project.id=" + project;
    }

    if (user) {
      filterUrl += "&project.user.id=" + user;
    }

    axios.get("/api/connections" + filterUrl, userAuthenticationConfig()).then(response => {
      if (response.status === HTTP_STATUSES.HTTP_OK) {
        const connectionList = response.data["hydra:member"];

        if (autoSelectSingle && connectionList && connectionList.length === 1) {
          setConnections(connectionList);
          setCheckedConnection(connectionList[0]);
          setFetchingConnections(false);

          return;
        }

        setConnections(connectionList);
        setFetchingConnections(false);
      }
    }).catch(error => {
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    });
  }, [project, service, user]);

  useEffect(() => {
    if (connections && connections.length > 0) {
      const connection = connections.find((connection) => connection.id === checkedConnection?.id);

      if (connection) {
        setCheckedConnection(connection);
      }
    }
  }, [connections]);

  if (fetchingConnections) {
    return <Skeleton
      variant="rect"
      height={46}
    />;
  }

  if (Object.keys(connections).length === 0) {
    return "Empty Connections";
  }

  if (autoSelectSingle && connections && connections.length === 1) {
    return null;
  }

  return (
    <>
      <Notification
        notification={notification}
        setNotification={setNotification}
      />
      <FormControl error={error} ref={refField}>
        <Autocomplete
          options={(isObject ? connections : connections.map(connection => connection.name)) || []}
          value={checkedConnection || null}
          onChange={(event, checkedConnection) => setCheckedConnection(checkedConnection)}
          getOptionLabel={(option) => isObject ? option.name : option}
          renderInput={(params) => (
            <TextField {...params} label={t("connection.name")} />
          )}
          blurOnSelect
          disableClearable={!defaultOption}
        />
        {error && <FormHelperText>{error}</FormHelperText>}
      </FormControl>
    </>
  );
};

export default ConnectionsSelect;